import Loading from './ant';

export default Loading;
